import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { LieferartListView } from './list-view/lieferart.list-view';

export const lieferartFieldOk: FieldOkConfig = {
  name: 'lieferart',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lieferart}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: LieferartListView,
        sort: {
          properties: [{ property: 'lieferart', title: 'Code' }],
        },
      },
    },
  ],
};

export const lieferartMultiselectFieldOk: FieldOkConfig = {
  name: 'lieferart',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lieferart}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: LieferartListView,
        sort: {
          properties: [{ property: 'lieferart', title: 'Code' }],
        },
      },
    },
  ],
};

export const lieferartQueryFieldOk: FieldOkConfig = {
  name: 'lieferart',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lieferart}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: LieferartListView,
        sort: {
          properties: [{ property: 'lieferart', title: 'Code' }],
        },
      },
    },
  ],
};
